import { render, staticRenderFns } from "./BalancoPatrimonialVersao.vue?vue&type=template&id=70ec80ae&scoped=true"
import script from "./BalancoPatrimonialVersao.vue?vue&type=script&lang=js"
export * from "./BalancoPatrimonialVersao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ec80ae",
  null
  
)

export default component.exports